import React from 'react';
import { Row, Column } from '@husslehq/ui-library';

import styles from '../../components/Breadcrumbs/Breadcrumbs.module.scss';

export const Breadcrumbs: React.FC<{ gymName: string; gymUrl: string; gymLocation: string }> = ({
  gymName,
  gymUrl,
  gymLocation,
}) => {
  return (
    <Row>
      <Column md="12">
        <ol className={styles.breadcrumbs} itemType="http://schema.org/BreadcrumbList">
          <li className={styles.breadcrumbs__element} itemProp="itemListElement" itemType="http://schema.org/ListItem">
            <a itemProp="item" href="/" title="Gyms">
              <span itemProp="name">Gyms</span>
            </a>
            <meta itemProp="position" content="1" />
          </li>
          <li className={styles.breadcrumbs__element} itemProp="itemListElement" itemType="http://schema.org/ListItem">
            <a itemProp="item" href={'/' + gymUrl.split('/')[1]}>
              <span itemProp="name" title={gymLocation + ' Gyms'}>
                {gymLocation} Gyms
              </span>
            </a>
            <meta itemProp="position" content="2" />
          </li>
          <li
            className={`${styles.breadcrumbs__element} ${styles.active}`}
            itemProp="itemListElement"
            itemType="http://schema.org/ListItem"
            title={gymName}
          >
            <a itemProp="item" href={gymUrl}>
              <span itemProp="name">{gymName}</span>
            </a>
            <meta itemProp="position" content="3" />
          </li>
        </ol>
      </Column>
    </Row>
  );
};
